import styled from 'styled-components';

import { Switcher } from 'components/modules/Insurance/Insurance.styles';

export const IndependentSwitcher = styled(Switcher)`
  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export * from 'components/modules/Insurance/Insurance.styles';
